import { Component, OnInit } from '@angular/core';
import { MatDialogRef,MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-infos',
  templateUrl: './infos.component.html',
  styleUrls: ['./infos.component.css']
})
export class InfosComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<InfosComponent>) { }

  ngOnInit() {
  }

  close() {

  this.dialogRef.close({ event: 'close', data:"close Info" });
  
 }

}
